import { MonitoringActionProperties } from 'models';
import { MonitoringAlarmProperties } from 'models/monitoring-alarm';
import { rest } from 'utils';

export default {
  action: {
    getAll: () => rest.get({ baseUrl: 'monitoring', url: '/actions?depth=2' }),
    create: (properties = new MonitoringActionProperties()) => rest.post({ baseUrl: 'monitoring', url: '/actions', body: { properties } }),
    get: ({ id }) => rest.get({ baseUrl: 'monitoring', url: `/actions/${id}?depth=2` }),
    update: ({ id, properties = new MonitoringActionProperties() }) => (
      rest.put({ baseUrl: 'monitoring', url: `/actions/${id}`, body: { properties } })
    ),
    delete: ({ id }) => rest.delete({ baseUrl: 'monitoring', url: `/actions/${id}` }),
    getAllExecutions: ({ actionId }) => rest.get({ baseUrl: 'monitoring', url: `/actions/${actionId}/executions?depth=2` }),
    getExecution: ({ actionId, executionId }) => rest.get({ baseUrl: 'monitoring', url: `/actions/${actionId}/executions/${executionId}?depth=2` }),
  },

  alarm: {
    getAll: () => rest.get({ baseUrl: 'monitoring', url: '/alarms?depth=2' }),
    create: (properties = new MonitoringAlarmProperties()) => rest.post({ baseUrl: 'monitoring', url: '/alarms', body: { properties } }),
    get: ({ id }) => rest.get({ baseUrl: 'monitoring', url: `/alarms/${id}?depth=2` }),
    update: ({ id, properties = new MonitoringAlarmProperties() }) => rest.put({ baseUrl: 'monitoring', url: `/alarms/${id}`, body: { properties } }),
    delete: ({ id }) => rest.delete({ baseUrl: 'monitoring', url: `/alarms/${id}` }),
    getAllTransitions: ({ alarmId }) => rest.get({ baseUrl: 'monitoring', url: `/alarms/${alarmId}/transitions?depth=2` }),
    getTransition: ({ alarmId, transitionId }) => rest.get({ baseUrl: 'monitoring', url: `/alarms/${alarmId}/transitions/${transitionId}?depth=2` }),
  },
};
